import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const directory = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/user/directory/`,
        {
					headers: {
					"Authorization": `Bearer ${sessionStorage.getItem("accessToken")}`,
					},
        },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch User Error:", error);
    throw error;
  }
};
